import { render, staticRenderFns } from "./DraggableListComponent.vue?vue&type=template&id=17e2646b&scoped=true&"
import script from "./DraggableListComponent.vue?vue&type=script&lang=js&"
export * from "./DraggableListComponent.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListComponent.vue?vue&type=style&index=0&id=17e2646b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2646b",
  null
  
)

export default component.exports